import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Homepage from './page/Homepage';
import Construct from './page/Construct';
import App from './page/App';
import reportWebVitals from './reportWebVitals';

const urlParams = new URLSearchParams(window.location.search);
const urlLoc = window.location.pathname;
const root = ReactDOM.createRoot(document.getElementById('root'));

function fSelectPage(sSystem, sMobile)
{
  if((sSystem=='bos') || (sSystem=='pbi') || (sSystem=='lna') || (sSystem=='syd') || (sSystem=='djt') )
  {
    return <Homepage sSystemName={sSystem} />
  }

 // if(sSystem)
 // {
 //   return <Homepage sSystemName={sSystem} />
 // }

  //return <Construct />
  return <App />
}

root.render(
  <React.StrictMode>
    { fSelectPage(urlParams.get('airport'))}
  </React.StrictMode>
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
